import React, { createContext, useContext } from 'react'
import { connect } from 'react-redux'
import {
  openParentWindow,
  navigateParentWindow,
  downloadFile
} from '../utils/navigation'
import { selectIsOrionSales } from '../selectors/session'

export const ParentWindowContext = createContext({
  urls: {},
  open: null,
  navigate: null,
  downloadFile
})

const useParentWindow = () => {
  const { urls , isOrionSales} = useContext(ParentWindowContext)

  const openWindow = (url, target = '_blank') => {
    if (isOrionSales) {
      window.open(url, target, 'noopener,noreferrer')
    } else {
      openParentWindow(url, target)
    }
  }

  return {
    urls,
    isOrionSales,
    open: openWindow,
    navigate: navigateParentWindow,
    downloadFile
  }
}

export const ParentWindowProvider = connect(state => ({
  urls: state.session.salesforce.urls,
  isOrionSales: selectIsOrionSales(state)
}))(({ children, ...props }) => (
  <ParentWindowContext.Provider value={props}>
    {children}
  </ParentWindowContext.Provider>
))

export default useParentWindow
